<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on }">
      <v-btn rounded class="primary text-capitalize f-14 lh-17 mt-2" v-on="on">
        <v-icon>mdi-filter-outline</v-icon>
        Filter
      </v-btn>
    </template>
    <v-form ref="form">
      <v-card class="rounded-12">
        <v-card-title
          class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
        >
          <span class="pa-0">Filter</span>
          <v-spacer></v-spacer>
          <v-btn color="white" fab x-small depressed>
            <v-icon
              @click="dialog = false"
              color="primary"
              class="fs-18 font-weight-bold"
            >
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-6 py-4 border-b-1">
          <div class="mb-3">
            <v-row>
              <v-col>
                <label
                  class="mb-1 d-block fs-14 font-weight-500"
                  for="yearStart"
                >
                  Year Start
                </label>
                <v-autocomplete
                  id="yearStart"
                  :items="years"
                  v-model="yearStart"
                  single-line
                  dense
                  hide-details
                  placeholder="Select Year Start"
                  append-icon="mdi-calendar"
                  :rules="yearStartRules"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col>
                <label class="mb-1 d-block fs-14 font-weight-500" for="yearEnd">
                  Year End
                </label>
                <v-autocomplete
                  id="yearEnd"
                  :items="years"
                  v-model="yearEnd"
                  single-line
                  dense
                  hide-details
                  placeholder="Select Year End"
                  append-icon="mdi-calendar"
                  :rules="yearEndRules"
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>
          </div>
          <div class="mb-3">
            <label class="mb-1 d-block fs-14 font-weight-500" for="house"
              >House</label
            >
            <v-autocomplete
              single-line
              dense
              hide-details
              id="house"
              placeholder="Select House"
              item-text="name"
              item-value="name"
              :items="houses"
              v-model="house"
              outlined
            ></v-autocomplete>
          </div>
          <div class="mb-3">
            <label class="mb-1 d-block fs-14 font-weight-500" for="region"
              >Region</label
            >
            <v-autocomplete
              single-line
              dense
              hide-details
              id="region"
              placeholder="Select Region"
              v-model="region"
              :items="regionItems"
              item-text="r_name"
              item-value="r_name"
              outlined
            ></v-autocomplete>
          </div>
          <div class="mb-3">
            <label class="mb-1 d-block fs-14 font-weight-500" for="district"
              >District</label
            >
            <v-autocomplete
              single-line
              dense
              hide-details
              id="district"
              placeholder="Select District"
              v-model="district"
              :items="districtItems"
              item-text="d_name"
              item-value="d_name"
              outlined
            ></v-autocomplete>
          </div>
          <div class="mb-0">
            <label class="mb-1 d-block fs-14 font-weight-500" for="status">
              By Status
            </label>
            <v-autocomplete
              v-model="status"
              single-line
              dense
              hide-details
              id="status"
              placeholder="Select Status"
              :items="statuses"
              item-text="local_status"
              item-value="local_status"
              multiple
              outlined
            ></v-autocomplete>
          </div>
        </v-card-text>
        <v-card-actions class="px-3">
          <v-col cols="4">
            <v-btn
              block
              color="#6A7589"
              dark
              rounded
              class="btn-medium rounded-xl px-4"
              @click="resetFilter"
            >
              <v-icon class="mr-2">mdi-refresh</v-icon>
              Reset Filter
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              block
              color="info"
              rounded
              class="btn-medium rounded-xl px-4"
              @click="handleDownload"
            >
              <v-icon class="mr-2">mdi-download</v-icon>
              Download
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              block
              color="primary"
              rounded
              class="btn-medium rounded-xl px-4"
              @click="handleFilter"
            >
              <v-icon class="mr-2">mdi-filter-outline</v-icon>
              Filter
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { yearOptions } from '@/utils/helpers';
import { mapState } from 'vuex';

export default {
  name: 'dashboard-filter',
  data: () => ({
    dialog: false
  }),
  computed: {
    ...mapState('sshcf', [
      'regions',
      'houses',
      'districts',
      'filter',
      'statuses'
    ]),
    years() {
      return yearOptions();
    },
    regionItems() {
      return this.regions?.result || [];
    },
    districtItems() {
      if (this.region) return this.districts;

      return this.districts?.result || [];
    },
    region: {
      set(val) {
        this.setFilter({
          region: val
        });
      },
      get() {
        return this.$store.getters['sshcf/filter'].region;
      }
    },
    house: {
      set(val) {
        this.setFilter({
          house: val
        });
      },
      get() {
        return this.$store.getters['sshcf/filter'].house;
      }
    },
    district: {
      set(val) {
        this.setFilter({
          district: val
        });
      },
      get() {
        return this.$store.getters['sshcf/filter'].district;
      }
    },
    yearStart: {
      set(val) {
        this.setFilter({
          yearStart: val
        });
      },
      get() {
        return this.$store.getters['sshcf/filter'].yearStart;
      }
    },
    yearEnd: {
      set(val) {
        this.setFilter({
          yearEnd: val
        });
      },
      get() {
        return this.$store.getters['sshcf/filter'].yearEnd;
      }
    },
    status: {
      set(val) {
        this.setFilter({
          status: val
        });
      },
      get() {
        return this.$store.getters['sshcf/filter'].status;
      }
    },
    yearStartRules() {
      if (this.yearEnd < this.yearStart) {
        return ['Year End can not lower than Year Start'];
      }
      return [];
    },
    yearEndRules() {
      if (this.yearStart > this.yearEnd) {
        return ['Year Start can not greater than Year End'];
      }
      return [];
    }
  },
  watch: {
    region(val) {
      const region = this.regionItems.find(item => item.r_name === val);
      if (val) {
        this.district = null;
        this.fetchDistricts(region?.id);
      }
    }
  },
  mounted() {
    this.fetchRegions();
    this.fetchHouses();
    this.fetchDistricts();
    this.fetchStatuses();
  },
  methods: {
    fetchStatuses() {
      return this.$store.dispatch('sshcf/getStatus');
    },
    setFilter(val = {}) {
      this.$store.commit('sshcf/set', {
        filter: {
          yearStart: this.yearStart,
          yearEnd: this.yearEnd,
          house: this.house,
          region: this.region,
          district: this.district,
          status: this.status,
          ...val
        }
      });
    },
    handleDownload() {
      this.setFilter({
        isDownload: true
      });
      this.$emit('download');
    },
    resetFilter() {
      this.setFilter({
        yearStart: '',
        yearEnd: '',
        house: null,
        region: null,
        district: null,
        status: [],
        isSubmit: true,
        isDownload: false
      });
      this.$emit('reset');
    },
    handleFilter() {
      if (this.$refs.form.validate()) {
        this.setFilter({
          isSubmit: true
        });
        this.$emit('filter');
      }
    },
    fetchHouses() {
      return this.$store.dispatch('sshcf/getHouses');
    },
    fetchRegions() {
      this.$store.dispatch('sshcf/getRegions', {
        limit: -1
      });
    },
    fetchDistricts(id) {
      if (!id) return;

      this.$store.dispatch('sshcf/getDistrictsByRegion', id, {
        limit: -1
      });
    }
  }
};
</script>
